import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import { Form, FormControl, FormGroup } from 'react-bootstrap-5';

import ManagedInput from 'components/form/managed_input';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.scss';

export default class FilterDatePickerPair extends React.Component {
  static propTypes = {
    ...FormControl.propTypes,
    filter: PropTypes.object.isRequired,
    inputsOnly: PropTypes.bool,
    label: PropTypes.string,
    maxPlaceholder: PropTypes.string,
    minPlaceholder: PropTypes.string,
    placeholder: PropTypes.string,
    valueKeys: PropTypes.array.isRequired,
    withIcon: PropTypes.any,
    onChange: PropTypes.func.isRequired,
  };

  minKey = () => this.props.valueKeys[0];
  maxKey = () => this.props.valueKeys[1];

  minValue = () => this.props.filter[this.minKey()];
  maxValue = () => this.props.filter[this.maxKey()];

  handleMaxChange = (e) => {
    this.props.onChange(e, this.maxKey());
  };

  handleMinChange = (e) => {
    this.props.onChange(e, this.minKey());
  };

  render() {
    const { inputsOnly, label } = this.props;
    let endDate = this.maxValue();
    if (endDate) endDate = moment(endDate);
    let startDate = this.minValue();
    if (startDate) startDate = moment(startDate);

    return (
      <div className="d-flex flex-column gap-1">
        {label && <Form.Label>{label}</Form.Label>}
        <FormGroup className="d-flex align-items-center gap-1">
          {this.renderMin(startDate, endDate)}
          {!inputsOnly && (
            <span>-</span>
          )}
          {this.renderMax(startDate, endDate)}
        </FormGroup>
      </div>
    );
  }

  renderMin(startDate, endDate) {
    const { minPlaceholder, placeholder, withIcon } = this.props;

    return (
      <div className="input-group flex-nowrap overflow-visible">
        {withIcon && (
          <div className="input-group-text">
            <FontAwesomeIcon className="input-icon" icon={withIcon} />
          </div>
        )}
        <ManagedInput
          aria-label={`minimum ${this.props['aria-label']}`}
          className={`input-selection form-control`}
          endDate={endDate}
          name={`${name}_min`}
          placeholder={minPlaceholder || placeholder || 'Start'}
          selectsStart
          startDate={startDate}
          type="date"
          value={startDate}
          onValueChange={this.handleMinChange}
        />
      </div>
    );
  }

  renderMax(startDate, endDate) {
    const { maxPlaceholder, placeholder, withIcon } = this.props;

    return (
      <div className="input-group flex-nowrap overflow-visible">
        {withIcon && (
          <div className="input-group-text">
            <FontAwesomeIcon className="input-icon" icon={withIcon} />
          </div>
        )}
        <ManagedInput
          aria-label={`maximum ${this.props['aria-label']}`}
          className={`input-selection form-control`}
          endDate={endDate}
          name={`${name}_max`}
          placeholder={maxPlaceholder || placeholder || 'End'}
          selectsEnd
          startDate={startDate}
          type="date"
          value={endDate}
          onValueChange={this.handleMaxChange}
        />
      </div>
    );
  }
}
